__turbopack_context__.v({
  "container": "_4SGAOq_container",
  "containerDark": "_4SGAOq_containerDark",
  "containerLight": "_4SGAOq_containerLight",
  "dateContainer": "_4SGAOq_dateContainer",
  "dateStyle": "_4SGAOq_dateStyle",
  "dateStyleDark": "_4SGAOq_dateStyleDark",
  "dateStyles": "_4SGAOq_dateStyles",
  "imgStyles": "_4SGAOq_imgStyles",
  "imgWrapper": "_4SGAOq_imgWrapper",
  "marginBotton10": "_4SGAOq_marginBotton10",
  "marginBotton15": "_4SGAOq_marginBotton15",
  "marginBt10Larg": "_4SGAOq_marginBt10Larg",
  "marginTop20px": "_4SGAOq_marginTop20px",
  "tagStyleDark": "_4SGAOq_tagStyleDark",
  "tagStylesText1": "_4SGAOq_tagStylesText1",
  "tagStylesTextDark": "_4SGAOq_tagStylesTextDark",
  "timeDuration": "_4SGAOq_timeDuration",
  "titleStyles": "_4SGAOq_titleStyles",
  "titleStylesDark": "_4SGAOq_titleStylesDark",
  "verticalLline": "_4SGAOq_verticalLline",
});
